import React, {Component} from "react";
import {Avatar as UserAvatar, Badge, Divider, Dropdown, Menu} from "antd";
import {NotificationOutlined} from "@ant-design/icons";
// import {getToken} from '../../services/firebase/messaging';
import {connect} from "react-redux";
import moment from "moment";

class Notification extends Component<any, any> {
    private readonly initState!: any;

    constructor(props: any) {
        super(props);
        this.initState = {
            // isTokenFound: false
        }
        this.state = {...this.initState}
    }

    // async getFirebaseToken() {
    //     getToken().then(r => {
    //         this.setState({
    //             isTokenFound: r
    //         });
    //     });
    // }

    componentDidMount() {
        // this.getFirebaseToken();
    }

    render() {
        const notificationList = (
            <Menu>
                {
                    this.props?.listNotification.map((item: any, i: number) =>
                        <Menu.Item key={i}>
                            <div style={{minWidth:280}}>
                                <span>{item.title}</span><br/>
                                <i style={{fontSize: "90%", color:"grey"}}>{item.message}</i><br/>
                                <span style={{float:"right", fontSize: "80%"}}>{moment.unix(item.time/1000).format("HH:mm")}</span><br/>
                            </div>
                            <Divider style={{marginTop:0,marginBottom:0}}/>
                        </Menu.Item>
                    )
                }
            </Menu>
        );

        return (
            <React.Fragment>
                <Dropdown className={'header-right-margin-left'} overlay={notificationList}>
                    <span className="action account">
                        <Badge count={ (this.props?.listNotification[0]?.title === "-") ? 0 : this.props?.listNotification.length ?? 0}>
                            <UserAvatar size="small" icon={<NotificationOutlined/>} className="avatar"/>
                        </Badge>
                    </span>
                </Dropdown>
            </React.Fragment>
        );
    }
}

const reduxState = (state: any) => ({
    listNotification: state.RlistNotification,
});

const reduxDispatch = (dispatch: any) => ({

});

export default connect(reduxState, reduxDispatch)(Notification);
